import React, { useState, useEffect } from 'react';
import Api from '../../api/global.service';
import BlockUi from 'react-block-ui';
import Swal from 'sweetalert2';
import env from '../../environment';

const ParcelasAlertas = ({ uuid, hasPolygon }) => {
  const [alertas, setAlertas] = useState([]);
  const [blocking, setBlocking] = useState(false);

  const getAlertas = () => {
    setBlocking(true);

    return Api.get('parcelas_alertas', uuid)
      .then(response => {
        setAlertas(response.data);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error('error', e);
        setBlocking(false);
      });
  };

  useEffect(() => {
    if (uuid != null) {
      getAlertas();
    }
  }, []);

  const handleEliminarAlerta = alerta => {
    Swal.fire({
      title: '¿Está seguro?',
      text: 'La alerta se eliminará',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(result => {
      if (!result.isConfirmed) return;

      Api.deleteWithBody('parcelas_alertas', uuid, { ids: [alerta.pivot.id] })
        .then(response => {
          if (response.data?.eliminadas > 0) {
            setAlertas(prev => prev.filter(a => a.pivot.id !== alerta.pivot.id));
            Swal.fire({
              icon: 'success',
              title: '',
              text: 'Se eliminó la alerta correctamente',
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: '',
              text: 'No se eliminó la alerta',
            });
            getAlertas();
          }
        })
        .catch(e => {
          Swal.fire({
            icon: 'error',
            title: '',
            text: e.response?.data?.message || 'No se pudo eliminar la alerta',
          });
        });
    });
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
      {alertas.length === 0 && hasPolygon && (
        <div
          style={{
            backgroundColor: '#F6F7F5',
            padding: 20,
            borderRadius: 10,
            textAlign: 'center',

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
          }}>
          <p style={{ marginBottom: 0 }}>
            <i
              className="fa fa-check"
              style={{
                color: '#789D16',
                marginRight: 10,
              }}
            />
            No se detectaron alertas
          </p>
        </div>
      )}
      {alertas.length > 0 &&
        hasPolygon &&
        alertas.map(alerta => {
          const isError = Number(alerta.error) === 1;
          return (
            <div
              key={alerta.pivot.id}
              style={{
                backgroundColor: isError ? '#FFEED9' : '#F6F7F5',
                padding: isError ? '8px 0 15px 12px' : 20,
                borderRadius: 10,
                textAlign: 'center',

                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: 10,
              }}>
              {isError ? (
                <div
                  style={{
                    padding: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'baseline',
                  }}>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                    style={{
                      color: '#E49D2A',
                      marginRight: 10,
                    }}
                  />
                </div>
              ) : null}

              <div style={{ flex: 1 }}>
                <p style={{ fontWeight: 'bold', textAlign: 'left', marginBottom: 5 }}>{alerta.titulo}</p>
                <p style={{ marginBottom: 8, textAlign: 'left' }}>{alerta.descripcion}</p>
                <p className="text-muted small" style={{ marginBottom: 0, textAlign: 'left' }}>
                  <i className="fa fa-lightbulb" style={{ color: env.colors.secondary_300, marginRight: 6 }} aria-hidden="true"></i>
                  <span style={{ fontWeight: 'bold' }}>Recomendación: </span>
                  {alerta.recomendacion}
                </p>
              </div>

              {!isError ? (
                <button
                  type="button"
                  className="btn btn-sm"
                  title="Eliminar alerta"
                  onClick={() => handleEliminarAlerta(alerta)}
                  style={{ marginLeft: 'auto' }}>
                  <i className="fa fa-trash" style={{ color: env.colors.error }}></i>
                </button>
              ) : null}
            </div>
          );
        })}
    </BlockUi>
  );
};

export default ParcelasAlertas;
